import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  MtSettingsBuyerUpdateProfileMutation,
  MtSettingsBuyerUpdateProfileMutationVariables,
} from '@gql/graphql';
import type { MtSettingsBuyerPageFormValues } from '@presentation/pages';
import { useCallback } from 'react';
import { useProfileUpdateBuilder } from './useProfileUpdateBuilder';

export const MT_SETTINGS_BUYER_UPDATE_PROFILE = graphql(`
  mutation MtSettingsBuyerUpdateProfile($data: AccountUpdateInput!, $profileImage: Upload) {
    accountMeUpdate(data: $data, profileImage: $profileImage) {
      ...MtSettingsBuyerProfile
    }
  }
`);

export const useUpdateProfile = () => {
  const { profileUpdateBuilder } = useProfileUpdateBuilder();

  const [updateProfile, { error, loading }] = useMutation<
    MtSettingsBuyerUpdateProfileMutation,
    MtSettingsBuyerUpdateProfileMutationVariables
  >(MT_SETTINGS_BUYER_UPDATE_PROFILE);

  const updateProfileFromForm = useCallback(
    async (form: MtSettingsBuyerPageFormValues) => {
      const { data } = profileUpdateBuilder(form);

      await updateProfile({
        variables: {
          ...(form.image instanceof File ? { profileImage: form.image } : {}),
          data,
        },
      });
    },
    [profileUpdateBuilder, updateProfile],
  );

  return {
    updateProfileLoading: loading,
    updateProfileError: error,
    updateProfileFromForm,
    updateProfile,
  };
};
